import Splide from '@splidejs/splide'

export function initFrontPage() {
    const frontPage = document.querySelector(".frontPage")
    if (frontPage) {
        setupFrontPage(frontPage)
    }
}

function setupFrontPage(frontPage) {
    const frontPageCompanies = frontPage.querySelector('.frontPage-companies-slider')

    if (frontPageCompanies) {
        new Splide(frontPageCompanies, {
            perPage: 5,
            perMove: 1,
            autoplay: true,
            pagination: false,
            type: 'loop',
            focus: 'center',
            gap: '20px',
            padding: {
                right: '3rem',
                left: '3rem',
            },
            breakpoints: {
                1024: {
                    perPage: 3,
                },
                680: {
                    perPage: 2,
                },
                480: {
                    perPage: 1,
                    gap: '15px',
                    padding: {
                        right: '2.5rem',
                        left: '2.5rem',
                    },
                },
            }
        }).mount()
    }
}
